export enum ADStatus {
    NotInAD = 0,
    Active = 1,
    Expired = 2
}

export enum ADStatusDescriptions {
    "No Account" = 0,
    "Active" = 1,
    "Expired" = 2
}

export enum EmployeeTTIAffiliation {
    AffiliatedWithTTI = 0,
    PI = 1,
    PaidOnProject = 2,
    PIPaidOnProjectAffiliatedWithTTI = 3,
    ResearchAffiliate = 4,
    ResearchAffiliatePIAffiliatedWithTTI = 5,
    ResearchAffiliatePaidOnProjectAffiliatedWithTTI = 6,
    ResearchAffiliatePIPaidOnProjectAffiliatedWithTTI = 7,
    OnStateSponsoredProject = 8,
    PIOnStateSponsoredProjectAffiliatedWithTTI = 9,
    PaidOnProjectOnStateSponsoredProjectAffiliatedWithTTI = 10,
    PIPaidOnProjectOnStateSponsoredProjectAffiliatedWithTTI = 11,
    ResearchAffiliateOnStateSponsoredProjectAffiliatedWithTTI = 12,
    ResearchAffiliatePIOnStateSponsoredProjectAffiliatedWithTTI = 13,
    ResearchAffiliatePaidOnProjectOnStateSponsoredProjectAffiliatedWithTTI = 14,
    ResearchAffiliatePIPaidOnProjectOnStateSponsoredProjectAffiliatedWithTTI = 15
}

export enum EmployeeTTIAffiliationDescriptions {
    "PI/Co-PI on TTI Project" = 1,
    "PI/Co-PI on Sponsored TTI Project" = 9,
    "Paid on TTI Project" = 2,
    "Research Affiliate" = 4,
}

export enum EmployeeClassification {
    External = 0,
    TAMUSystem = 1,
    TTI = 2
}
  
export type PersonPayIndicatorListItem = {
    code: string;
    description: string;
    payFrequency: string;
}

export type PersonEmploymentStatusListItem = {
    code: string;
    name: string;
    indicatesIsActive: boolean;
}

export enum IncompleteRecordFlag {
    UIN = 0,
    Email = 1,
    FTE = 2,
    PayIndicator = 4,
    Supervisor = 8,
    Organization = 16,
    UINEmailSupervisor = 9,
    UINFTEPayIndicatorOrganization = 22,
    UINEmailSupervisorOrganization = 25
}

export type PersonFilterOptions = {
    page: number;
    pageSize: number;
    name: string | null;
    supervisorName: string | null;
    uin: string | null;
    organizationCode: string | null;
    organizationId: string | null;
    adStatus: number | null;
    employeeClassification: number | null;
    employeeTTIAffiliation: number | null;
    onlyShowActive: boolean;
    onlyShowTTI: boolean;
    onlyShowMissingAddress: boolean;
    returnAll: boolean;
    employeeType: string | null;
    employmentStatus: string | null;
    employeeTypes: Array<string> | null;
    employmentStatuses: Array<string> | null;
    payIndicators: Array<string> | null;
    isNonTTIEmployee: boolean | null;
    incompleteRecordFlags: number | null;
    externalOrganizationCode: string | null;
}

export type PersonListItem = {
    id: string;
    name: string;
    emailAddress: string | null;
    uin: string | null;
    organizationCode: string | null;
    employmentStatus: string | null;
    supervisorName: string | null;
    nonTTIProjectEmployeeType: string | null;
    inAD: boolean;
    expiredInAD: boolean;
    supervisoryOrganization: string | null;
    externalOrganization: string | null;
    employeeType: string | null;
    payIndicator: string | null;
    payType: string | null;
    payClassification: string | null;
    payFrequency: string | null;
    visaType: string | null;
    visaExpirationDate: Date | null;
}

export type Person = {
    id: string;
    oracleId: number | null;
    oracleUsername: string | null;
    netLoginId: string | null;
    emailAddress: string | null;
    emailAlias: string | null;
    networkBillingIndicator: boolean;
}

export type UpdatePerson = {
    id: string;
    oracleUserName: string | null;
    emailAlias: string | null;
    networkBillingIndicator: boolean;
}
